import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=7bb67903"
import script from "./TipDialog.vue?vue&type=script&lang=js"
export * from "./TipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb67903')) {
      api.createRecord('7bb67903', component.options)
    } else {
      api.reload('7bb67903', component.options)
    }
    module.hot.accept("./TipDialog.vue?vue&type=template&id=7bb67903", function () {
      api.rerender('7bb67903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/TipDialog.vue"
export default component.exports